<app-table
  [cols]="cols"
  modelName="pedidos"
  sortField="dateCreated"
  [sortOrder]="1"
  [service]="shippingOrderService"
  [findPage]="findPage"
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
  [defaultFilterValues]="defaultFilterValues"
  [changeColumns]="true"
  tableTitle="Pedidos glam"
/>
